import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isNil, isEmpty, get } from 'lodash';
import AnimateHeight from 'react-animate-height';

import { i18n } from '@lt/localization';

import ExtraRoomsItem from '../../../../components/ExtraRooms';

const baseCls = 'checkout-extra-rooms';

export class ExtraRooms extends Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();
  }

  componentDidMount() {
    const { prevScrollPosition, resetScrollPosition } = this.props;

    // срабатывает после выбора номера
    if (prevScrollPosition) {
      window.scrollTo(0, prevScrollPosition);
      resetScrollPosition();
    }
  }

  componentDidUpdate() {
    const { prevScrollPosition, resetScrollPosition } = this.props;
    const containerHeight = get(
      this,
      'container.current.contentElement.offsetHeight',
    );
    const scrollPosition = !isNil(prevScrollPosition);

    // срабатывает когда приходят данные
    if (scrollPosition && containerHeight) {
      const position = prevScrollPosition + containerHeight;

      // maintain scroll position after showing block
      window.scrollTo(0, position);
      resetScrollPosition();
    }
  }

  render() {
    const {
      touristsCount,
      offers,
      isMobile,
      currentPackageId,
      prevScrollPosition,
      ...props
    } = this.props;
    const hasOffers = !isEmpty(offers);
    const withAnimation = !prevScrollPosition;

    return (
      <AnimateHeight
        applyInlineTransitions={withAnimation}
        duration={500}
        height={hasOffers ? 'auto' : 0}
        className={baseCls}
        ref={this.container}
      >
        <h2 className={`${baseCls}__title like-h2`}>
          {i18n.t('checkout.extraRooms.title')}
        </h2>
        {hasOffers && (
          <ul className={`${baseCls}__list`}>
            {offers.map((item, index) => {
              const params = {
                item,
                index,
                baseCls,
                isMobile,
                currentPackageId,
                touristsCount,
                ...props,
              };

              return <ExtraRoomsItem key={item.name_en} {...params} />;
            })}
          </ul>
        )}
      </AnimateHeight>
    );
  }
}

ExtraRooms.defaultProps = {
  offers: null,
  prevScrollPosition: null,
};

ExtraRooms.propTypes = {
  offers: PropTypes.arrayOf(PropTypes.shape({})), // TODO: PropTypes
  onClick: PropTypes.func.isRequired,
  aboutRoomOnClick: PropTypes.func.isRequired,
  currentPackageId: PropTypes.number.isRequired,
  originalPackageId: PropTypes.number.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isServicesPath: PropTypes.bool.isRequired,
  prevScrollPosition: PropTypes.number,
  resetScrollPosition: PropTypes.func.isRequired,
};
